module.exports = __webpack_public_path__ + "static/assets/b3cd90ba16ab503943c4b0e87b5df175.png";